import React from "react";

// design doc section 9.1: first load only (no items yet). A refetch after a
// filter/sort change keeps the existing list dimmed instead -- see
// KitsCatalogue's `refetching` state, which does not render this. Same row
// shape as KitRow, so nothing jumps when the real rows land.
export default function KitsSkeleton() {
  return (
    <div className="mt-4 flex flex-col gap-2">
      {Array.from({ length: 8 }).map((_, i) => (
        <div
          key={i}
          className="feature-card rounded-lg px-3 py-3 sm:px-4 sm:py-2 animate-pulse flex flex-col gap-3 sm:flex-row sm:items-center sm:gap-5"
        >
          <div className="flex items-center gap-3 sm:w-80 sm:shrink-0">
            <div className="m-1.5 h-10 w-10 shrink-0 rounded-full bg-white/10" />
            <div className="flex-1">
              <div className="h-4 w-2/3 rounded bg-white/10" />
              <div className="mt-2 h-3 w-3/4 rounded bg-white/10" />
            </div>
          </div>
          <div className="h-16 w-full rounded-lg bg-white/5 sm:h-[72px] sm:w-auto sm:flex-1" />
        </div>
      ))}
    </div>
  );
}
